import { useEffect, useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import {
  getStoredGrant,
  isDemoVisitorMode,
  isGatedHost,
} from "@/lib/demoGate";

/**
 * `isDemo` is true when the current visitor is on the gated host with a
 * valid demo code but NO authenticated session. Use it to hide login /
 * signup CTAs and disable mutating actions.
 *
 * `isGated` is just whether we're on the gated host at all — useful for
 * conditionally rendering the "Demo mode" banner.
 */
export const useDemoMode = () => {
  const { user } = useAuth();
  const [tick, setTick] = useState(0);

  // Re-evaluate when localStorage changes from another tab and on focus,
  // so the gate state stays accurate after a code redemption.
  useEffect(() => {
    const onStorage = () => setTick((t) => t + 1);
    window.addEventListener("storage", onStorage);
    window.addEventListener("focus", onStorage);
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("focus", onStorage);
    };
  }, []);

  const _ = tick; // keep linter happy, dependency for re-render
  return {
    isGated: isGatedHost(),
    isDemo: isDemoVisitorMode(!!user),
    grant: getStoredGrant(),
  };
};
